import styled from 'styled-components';
import type { Color } from '../../styles/variables';
import { SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';
import {
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_50,
  SYS_SPACE_FIXED_150,
} from '@oneaudi/unified-web-common';

export const StatusContainer = styled.div`
  position: relative;
  margin-top: 0px;
  z-index: 2;
  @media ${device.tablet} {
    margin-top: ${SIZING.unit(4.25)};
  }
`;
export const StatusBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StatusText = styled.p`
  margin: 0px 8.7px 0px 10.5px;
`;

export const Status = styled.div<{ backColor: Color; textColor: Color }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  background-color: ${({ backColor }) => backColor || SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT};
  color: ${({ textColor }) => textColor || SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT};
  letter-spacing: 0.002px;
  padding: ${SYS_SPACE_FIXED_50}px ${SYS_SPACE_FIXED_150}px;
  width: max-content;
`;

export const StatusDot = styled.div<{ dotColor: Color }>`
  width: 8px;
  height: 8px;
  background: ${({ dotColor }) => dotColor || ''};
  border-radius: 50%;
  margin-right: ${SYS_SPACE_FIXED_100}px;
`;

export const StatusTitle = styled.div``;

export const InfoIconWrapper = styled.div`
  height: 20px;
  width: 20px;
  margin-left: ${SYS_SPACE_FIXED_100}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
